<section class="main-section-help-user-account" #userAccTop>
    <div>
        <div id="creatingUserMainSection" class="main_section_headers">
           <span i18n="@@ipos-help.main-section.create-user-account">Creating a User Account</span>
        </div>
        <div id="createAccountBody" class="ipos-help-create-account-body">
            <div id="createAccountDescription">
                <span i18n="@@ipos-help.main-section.create-account-description">In order to download the Intel Intelligent Point of Sale (IPOS) software, you’ll need to create a user account. Your user account is tied to an email address and requires a few key pieces of information. Field names ending in an “*” are required fields.</span>
            </div>
            <div id="createAccountDesc" class="ipos-help-create-account-desc">
                <span i18n="@@ipos-help.main-section.create-account-step">Please follow the below steps to create a user account:</span>
                <ol class="ipos-help-create-account-list">
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-select-language-msg">Select the <strong>Language</strong> in which you want the interface for account creation. You can also change the <strong>Language</strong> later by clicking the Language icon in the upper right corner.</span>
                    </li>
                    <img class="ipos-help-select-language-img" alt="select language">
                    
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-name-label">Enter the <strong>First Name</strong> and <strong>Last Name.</strong></span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-email-label">Enter the <strong>Email Address.</strong> This will be used as the Username for logon credentials.</span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-passwd-label">Enter the <strong>Password</strong> and <strong>Confirm Password.</strong> Please follow the below password policy and choose a strong password.</span>
                        <ul class="paswd-criteria-list">
                            <li>
                                <span i18n="@@ipos-help.main-section.create-account-subsection">At least <strong>5</strong> characters</span>
                            </li>
                            <li>
                                <span i18n="@@ipos-help.main-section.create-account-uppercase-label">Contains an uppercase letter</span>
                            </li>
                            <li>
                               <span i18n="@@ipos-help.main-section.create-account-lowercase-label">Contains a lowercase letter</span>
                            </li>
                            <li>
                                <span i18n="@@ipos-help.main-section.create-account-contain-number-label">Contains a number</span>
                             </li>
                             <li>
                                <span i18n="@@ipos-help.main-section.create-account-contain-symbol-label">Contains a symbol</span>
                             </li> 
                        </ul>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-select-location-label">Select the <strong>Location.</strong></span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-select-location-subsection">Enter the <strong>Retailer Name.</strong></span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-select-store-name-label">Enter the <strong>Store Name.</strong> This is an optional field.</span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-comment-label">Enter <strong>Comments</strong> if any, up to <strong>100 characters.</strong> This is an optional field.</span>
                    </li>
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-click-create-account-btn">Click the <strong>Create an Account</strong> button.</span>
                        
                    </li>
                    <img class="ipos-help-create-account-img" alt="create account image">
                    <li>
                        <span i18n="@@ipos-help.main-section.create-account-six-digit-confrm-code-msg">You will receive a 6-digit <strong>Confirmation Code</strong> via email.</span>
                        <ul class="confirmation-code-list">
                            <li>
                                <span i18n="@@ipos-help.main-section.create-account-confrm-code-info-msg">Enter the <strong>Confirmation Code</strong> and click the <strong>Confirm</strong> button.</span>
                            </li>
                            <li>
                                <span i18n="@@ipos-help.main-section.create-account-confrm-code-resend-msg">If you have not received the <strong>Confirmation Code,</strong> click the <strong>Resend Code</strong> button.</span>
                            </li>
                        </ul>
                        <img class="ipos-help-confirmation-code-img" alt="confirmation code">
                    </li>
                </ol>
                <span i18n="@@ipos-help.partner-portal.page-cg-note-text"><strong>Note:</strong></span>
                <ul>
                    <li i18n="@@ipos-help.main-section.create-account-request-approval">If your email domain isn’t on our domain allowlist, your account creation request will require approval. It will be reviewed by an admin within 24 hours and you will be notified via email after approval/rejection.</li>
                    <li i18n="@@ipos-help.main-section.above-unconnected-connected-intel-rep">The process mentioned above is to create a non-connected user account. To create a connected user account for remote device management, contact your Intel representative.</li>
                </ul>
            </div>
        </div>
    </div>
</section>


